import {
  documents,
  time,
  person,
  clipboard,
  car,
  copy,
  ticket,
  wallet,
  card,
  people,
  book,
  informationCircle,
  documentText,
  listCircle,
  hourglass,
  newspaper,
  calendar,
  cube,
  home,
  list,
  barcode,
  shareSocial,
} from "ionicons/icons";
//Chiave localsotrage
const LOCALSTORAGE_KEY = `user${process.env.VUE_APP_LOCALSTORAGE_KEY}`; // Pagina da vedere dopo il login
const pageAfterLogin = "clienti";

// Pulsanti presenti nella dashboard
const dashbordButtons = {
  presenze: true,
  documenti: true,
  richieste: true,
  automezzi: true,
  spese: true,
  tickets: true,
};
// Configurazione del menu
const config_menu = [
  {
    show: false,
    route: "presenze",
    icon: time,
    name: "Presenze",
    allowedRoles: [],
  },
  {
    show: false,
    route: "documenti",
    icon: documents,
    name: "Documenti",
    allowedRoles: [],
  },
  {
    show: false,
    route: "richieste",
    icon: clipboard,
    name: "Richieste",
    allowedRoles: [],
  },
  {
    show: false,
    route: "banca",
    icon: hourglass,
    name: "Banca ore",
    allowedRoles: [],
  },
  {
    show: false,
    route: "automezzi",
    icon: car,
    name: "Automezzi",
    allowedRoles: [],
  },
  {
    show: false,
    route: "spese",
    icon: wallet,
    name: "Note spesa",
    allowedRoles: [],
  },
  {
    show: false,
    route: "calendario",
    icon: calendar,
    name: "Calendario",
    allowedRoles: [],
  },
  {
    show: false,
    route: "rimborsi",
    icon: card,
    name: "Rimborsi km",
    allowedRoles: [],
  },
  {
    show: true,
    route: "clienti",
    icon: people,
    name: "Anagrafiche",
    allowedRoles: ["Admin", "Tecnico", "Capo cantiere", "Venditore", "Sales Agent", "Impiegato"],
  },
  {
    show: false,
    route: "progetti",
    icon: listCircle,
    name: "Progetti",
    allowedRoles: [],
  },
  {
    show: true,
    route: "leads",
    icon: book,
    name: "Leads",
    allowedRoles: ["Admin", "Venditore", "Sales Agent"],
  },
  {
    show: true,
    route: "interventi",
    icon: documentText,
    name: "Interventi",
    allowedRoles: ["Admin", "Tecnico", "Capo cantiere", "Impiegato"],
  },
  {
    show: false,
    route: "rapportini",
    icon: documentText,
    name: "Rapportini",
    allowedRoles: [],
  },
  {
    show: true,
    route: "tickets",
    icon: ticket,
    name: "Tickets",
    allowedRoles: ["Admin", "Tecnico", "Capo cantiere", "Impiegato"],
  },
  { show: false, route: "task", icon: home, name: "Tasks", allowedRoles: [] },
  {
    show: false,
    route: "timesheet",
    icon: time,
    name: "Timesheet",
    allowedRoles: [],
  },
  {
    show: false,
    route: "bacheca",
    icon: shareSocial,
    name: "Bacheca",
    allowedRoles: [],
  },
  {
    show: true,
    route: "programma",
    icon: calendar,
    name: "Programma lavoro",
    allowedRoles: ["Admin", "Tecnico", "Capo cantiere", "Impiegato"],
  },
  {
    show: false,
    route: "ordini",
    icon: cube,
    name: "Ordini interni",
    allowedRoles: [],
  },
  {
    show: false,
    route: "sondaggi",
    icon: newspaper,
    name: "Sondaggi",
    allowedRoles: [],
  },
  {
    show: false,
    route: "magazzino",
    icon: barcode,
    name: "Magazzino",
    allowedRoles: [],
  },
  {
    show: false,
    route: "movimenti",
    icon: barcode,
    name: "Movimenti",
    allowedRoles: [],
  },
  { show: false, route: "todo", icon: list, name: "Liste", allowedRoles: [] },
  {
    show: true,
    route: "profilo",
    icon: person,
    name: "Profilo",
    allowedRoles: ["Admin", "Tecnico", "Capo cantiere", "Venditore", "Impiegato"],
  },
];
/** * * RAPPORTINI * */
// Configurazione operatori e prodotti
const showOperatori = true;
const showProdotti = true;

/** * * TIMESHEET * */
// Configurazione input field da mostrare in creazone
const showTimesheetDateHour = false;

// Configurazione dei permessi per ruolo
const rolePermissions = {
  Admin: ["*"],
  // '*' indica accesso a tutte le rotte
  Tecnico: [
    "login",
    "clienti",
    "interventi",
    "tickets",
    "Programma Lavoro",
    "profilo",
    "changePassword",
  ],
  Impiegato: [
    "login",
    "clienti",
    "interventi",
    "tickets",
    "Programma Lavoro",
    "profilo",
    "changePassword",
  ],
  Venditore: [
    "login",
    "clienti",
    "leads",
    "profilo",
    "changePassword",
  ],
  "Sales Agent": [
    "login",
    "calendario",
    "clienti",
    "leads",
    "profilo",
    "changePassword",
  ],
};

export {
  LOCALSTORAGE_KEY,
  pageAfterLogin,
  dashbordButtons,
  config_menu,
  showProdotti,
  showOperatori,
  showTimesheetDateHour,
  rolePermissions,
};
